export default "__VITE_ASSET__BguDdEwr__"